import AdminResetPasswordWrapper from "../../components/Admin/AdminResetPasswordPage/AdminResetPasswordWrapper/AdminResetPasswordWrapper";

type Props = {};

const ResetPasswordPage = (props: Props) => {
  return <AdminResetPasswordWrapper />;
};

export default ResetPasswordPage;
